import { render, staticRenderFns } from "./HomeRouter.vue?vue&type=template&id=7b036ef9&"
import script from "./HomeRouter.vue?vue&type=script&lang=js&"
export * from "./HomeRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b036ef9')) {
      api.createRecord('7b036ef9', component.options)
    } else {
      api.reload('7b036ef9', component.options)
    }
    module.hot.accept("./HomeRouter.vue?vue&type=template&id=7b036ef9&", function () {
      api.rerender('7b036ef9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/views/HomeRouter.vue"
export default component.exports